export const fileWithMetaToFormData = (fileWithMeta: FileWithMeta): FormData => {
    const formData = new FormData();
    formData.append('file', fileWithMeta.file);
    formData.append('description', fileWithMeta.description);
    formData.append('documentTypeId', fileWithMeta.documentTypeId + '');
    return formData;
};

export type WithUploadStatus<T> = T & { status: UploadStatus };

export const isSameFile = (a: File, b: File): boolean => a.name === b.name && a.size === b.size;

export enum UploadStatus {
    READY,
    PENDING,
    DONE,
    ERROR,
}

export interface FileWithMeta {
    file: File;
    description: string;
    documentTypeId: number;
}
